import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/_/volunteers")({
	component: VolunteersLayout,
});

function VolunteersLayout() {
	return <Outlet />;
}
